import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@monksflow/monks-ui';
import { InfoIcon } from 'lucide-react';

import {
  OpportunityTypeBadge,
  DURATION_TYPE_VALUES,
  OPPORTUNITY_TYPE_INFO,
} from '@/entities/opportunity';
import { useTranslation } from 'react-i18next';

function InfoContent() {
  const { t } = useTranslation('analysis');

  return (
    <>
      <p className="text-sm font-medium text-foreground mb-3">
        {t('opportunitiesRoom.opportunityTypesInfoButton.opportunityTypes')}
      </p>
      <div className="flex flex-col gap-2.5">
        {DURATION_TYPE_VALUES.map((type) => {
          const { description, tags } = OPPORTUNITY_TYPE_INFO[type];
          return (
            <div
              key={type}
              className="rounded-lg border border-border-lighter p-4 flex flex-col gap-2"
            >
              <OpportunityTypeBadge type={type} />
              <p className="text-xs text-muted-foreground leading-relaxed">{description}</p>
              <div className="flex flex-wrap gap-1">
                {tags.map((tag) => (
                  <span
                    key={tag}
                    className="inline-flex items-center px-2 py-0.5 rounded-full border border-border text-xs text-foreground bg-background"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
}

const triggerClassName =
  'flex items-center justify-center size-6 rounded-full text-muted-foreground hover:text-foreground hover:bg-accent transition-colors';

export function OpportunityTypesInfoButton() {
  const { t } = useTranslation('analysis');

  return (
    <>
      {/* md+: hover card */}
      <span className="hidden md:inline-flex">
        <HoverCard openDelay={100} closeDelay={100}>
          <HoverCardTrigger asChild>
            <button
              type="button"
              aria-label={t(
                'opportunitiesRoom.opportunityTypesInfoButton.learnAboutOpportunityTypes',
              )}
              className={triggerClassName}
            >
              <InfoIcon className="size-4" />
            </button>
          </HoverCardTrigger>
          <HoverCardContent align="end" className="w-90 p-4">
            <InfoContent />
          </HoverCardContent>
        </HoverCard>
      </span>

      {/* below md: tap popover for phone a11y */}
      <span className="inline-flex md:hidden">
        <Popover>
          <PopoverTrigger asChild>
            <button
              type="button"
              aria-label={t(
                'opportunitiesRoom.opportunityTypesInfoButton.learnAboutOpportunityTypes',
              )}
              className={triggerClassName}
            >
              <InfoIcon className="size-4" />
            </button>
          </PopoverTrigger>
          <PopoverContent align="end" className="w-80 p-4">
            <InfoContent />
          </PopoverContent>
        </Popover>
      </span>
    </>
  );
}
